import BoldText from "../BoldText/BoldText";
import "../../index.css";
import "./ComingSoonCluster.css";

const DirectoryCluster= ({title, list =[], light=false}) => {

  return (
    <div className={`directory-cluster directory-cluster--dark`}>
      <img
        className="directory-cluster__rose"
        src="/photo-assets/red%20rose%20icon_alpha.png"
        alt=""
        aria-hidden="true"
      />
      <div className={"directory-cluster__content"} style={{marginBottom: "6vmax"}}>
        <BoldText clr="clr-dark-blue" marginClass={"margin-bottom-5"} class_Name="coming-soon-title" > {title}</BoldText>
      </div>
    </div>
  );
}; 


export default DirectoryCluster;